module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img46.4fba25e6.jpg";